const getLowestCostForRow = (row) => {
  if (!row) return 0;
  let costs = [row.costInsideFrom, row.costOceanviewFrom, row.costBalconyFrom, row.costSuiteFrom];
  const nonZeroCosts = costs.filter((c) => c && !!c.price);
  if (nonZeroCosts.length) {
    costs = nonZeroCosts;
    const price = Math.min(...costs.map((c) => c.price));
    return costs.find((c) => c.price === price);
  }
  return costs[0];
};

export default getLowestCostForRow;
